


export const showNumberRowsTable = 10;